export const reportsPermissions = (actions: Set<string>) => {
  const UPDATE_RECOMMENDATIONS = actions.has('update-recommendations')

  return {
    UPDATE_RECOMMENDATIONS,
  }
}
